import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import OurMissionValues from "./sections/OurMissionValues";
import SpecialOffer from "./sections/SpecialOffer";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <Overview />
      <OurMissionValues />
      <SpecialOffer />
      <Footer />
    </div>;
}